var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleG(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "G_Mark_1_",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5028877,10.2524272 C19.5028877,9.5231068 19.437851,8.82524272 19.3170685,8.15417476 L9.9703621,8.15417476 L9.9703621,11.998835 L15.3533124,12 C15.1349748,13.2792233 14.4323459,14.3697087 13.3557559,15.096699 L13.3557559,17.591068 L16.5599759,17.591068 C18.4309431,15.8539806 19.5028877,13.2862136 19.5028877,10.2524272 Z",
    id: "Blue_500",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3569172,15.096699 C12.464985,15.7001942 11.31639,16.0532039 9.97268484,16.0532039 C7.37702272,16.0532039 5.17506506,14.2986408 4.38649478,11.9335922 L1.08123554,11.9335922 L1.08123554,14.5060194 C2.71876735,17.7658252 6.08441783,20.0027184 9.97268484,20.0027184 C12.6600952,20.0027184 14.9177986,19.1161165 16.5611373,17.5899029 L13.3569172,15.096699 Z",
    id: "Green_500_1_",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0752476,10.0252427 C4.0752476,9.36116505 4.18557775,8.7192233 4.38649478,8.11572816 L4.38649478,5.54330097 L1.08123554,5.54330097 C0.404156786,6.89126214 0.0232274015,8.41281553 0.0232274015,10.0252427 C0.0232274015,11.6376699 0.405318156,13.1592233 1.08123554,14.5071845 L4.38649478,11.9347573 C4.18557775,11.3312621 4.0752476,10.6893204 4.0752476,10.0252427 Z",
    id: "Yellow_500_1_",
    fill: "#FABB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97268484,3.9961165 C11.4394952,3.9961165 12.7530048,4.50291262 13.7901083,5.49320388 L16.6296581,2.64699029 C14.9050236,1.03572816 12.6566111,0.0466019417 9.97268484,0.0466019417 C6.0855792,0.0466019417 2.71876735,2.28349515 1.08123554,5.54330097 L4.38649478,8.11572816 C5.17506506,5.75067961 7.37702272,3.9961165 9.97268484,3.9961165 Z",
    id: "Red_500",
    fill: "#E94235"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleG);
export default __webpack_public_path__ + "static/media/google-g.b61d7fd8b9a526cb3f149cde4a5ce403.svg";
export { ForwardRef as ReactComponent };